module.exports = require("@wildboar/x500/src/lib/modules/SchemaAdministration/DITContentRuleDescription.ta");